import React from 'react';
import Button from '@mui/material/Button';
import Loader from '@/components/common/Loader';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { Dialogs, useDialogManager } from '@/modules/Dialogs';
import useSortedCustomFields from '../../hooks/useSortedCustomFields';
import CustomFieldsList from './CustomFieldsList';

export default function CustomFieldsPage() {
  const { isLoading, noCustomFields } = useSortedCustomFields();
  const { openDialog, closeDialog } = useDialogManager();

  const showCreateCustomFieldDialog = () =>
    openDialog(Dialogs.CREATE_CUSTOM_FIELD, {
      onCancel: closeDialog,
      onClose: closeDialog,
    });

  return (
    <div className="max-w-5xl p-4">
      <h2 className="mb-4 type-h2">{translate('CUSTOM_FIELDS')}</h2>
      <p className="type-body1">{translate('CUSTOM_FIELDS_DESCRIPTION')}</p>
      <Button
        className="mt-6"
        onClick={showCreateCustomFieldDialog}
        variant="contained"
      >
        {translate('CUSTOM_FIELDS_CREATE_NEW')}
      </Button>
      {isLoading && <Loader isCentered />}
      {!isLoading && noCustomFields && (
        <div className="flex flex-col items-center pt-11 text-center">
          <h3 className="type-h3">{translate('CUSTOM_FIELDS_NO_ITEMS')}</h3>
          <div className="my-4 w-32 border border-0 border-b border-text-disabled" />
          <div className="text-text-secondary">
            {translate('CUSTOM_FIELDS_CREATE_ONE')}
          </div>
        </div>
      )}
      {!isLoading && <CustomFieldsList />}
    </div>
  );
}
